import { IncentivesActionType } from './enums';
import { IncentivesAction, IncentivesState } from './interfaces';

export const initialState: IncentivesState = {
	incentivesPercentageShare: {},
	incentivesPercentageShareLoading: false,

	teamWiseIncentivesList: [],
	teamWiseIncentivesListTotalRecords: 0,
	teamWiseIncnetivesListLoading: false,

	teamWiseIncentives: {},
	teamWiseIncentivesLoading: false
};

export default (state = initialState, { type, payload }: IncentivesAction): IncentivesState => {
	switch (type) {
		case IncentivesActionType.FETCH_TEAM_WISE_SHARE:
			return {
				...state,
				incentivesPercentageShareLoading: true
			};

		case IncentivesActionType.STORE_TEAM_WISE_SHARE:
			return {
				...state,
				incentivesPercentageShare: payload,
				incentivesPercentageShareLoading: false
			};



		case IncentivesActionType.FETCH_TEAM_WISE_INCENTIVES:
			return {
				...state,
				teamWiseIncnetivesListLoading: true
			};

		case IncentivesActionType.STORE_TEAM_WISE_INCENTIVES:
			return {
				...state,
				teamWiseIncentivesList: payload.teamWiseIncentives,
				teamWiseIncentivesListTotalRecords: payload.totalRecords,
				teamWiseIncnetivesListLoading: false
			};



		case IncentivesActionType.FETCH_TEAM_WISE_INCENTIVES_BY_PROJECT_ID:
			return {
				...state,
				teamWiseIncentivesLoading: true
			};


		case IncentivesActionType.STORE_TEAM_WISE_INCENTIVES_BY_PROJECT_ID:
			return {
				...state,
				teamWiseIncentives: payload,
				teamWiseIncentivesLoading: false
			};

		default:
			return state;
	}
};
